import * as React from 'react';
import { styledListingCardPortraitStyle } from './ListingCardPortrait.styles.css';

export type ListingCardProps = {
    testId: string;
    listingLinkHref: string;
    onClick: () => void;
    children?: React.ReactNode;
};

// TODO: ZDSU Understand custom image requirements
// margin: 0;
// min-width: 100%;
// height: 100%;
// object-fit: cover;
export const ListingCardPortrait = ({
    testId,
    listingLinkHref,
    onClick,
    children
}: ListingCardProps) => {
    return listingLinkHref ? (
        <a
            className={styledListingCardPortraitStyle}
            data-testid={testId}
            href={listingLinkHref}
            onClick={onClick}
        >
            {children}
        </a>
    ) : (
        <div className={styledListingCardPortraitStyle} data-testid={testId}>
            {children}
        </div>
    );
};
